import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useAuthContext } from "app/contexts/auth";
import { useProfileContext } from "app/contexts/profile";

export function UserProfile() {
  const { logout } = useAuthContext();
  const { profile } = useProfileContext();

  return (
    <Container
      maxWidth="xs"
      className="animate__animated animate__fadeIn"
      sx={{ padding: 4 }}
    >
      <Paper sx={{ padding: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="overline">
              <strong>Perfil de usuario</strong>
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Nombre completo"
              value={profile.usuario_nombre_completo}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Usuario"
              value={profile.usuario_username}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Correo electrónico"
              value={profile.usuario_correo_electronico}
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" justifyContent="end">
              <Button variant="contained" onClick={logout}>
                Cerrar sesión
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
